<template>
  <span class="">
    <el-button
      ref="btnPrint"
      class="btn"
      :class="options.addClass ? options.addClass : ''"
      :size="options.size ? options.size : 'small'"
      :type="options.btnType ? options.btnType : ''"
      :loading="keyBtn"
      @click.native="openMenu($event)"
      v-if="hasPower"
      :disabled="isDisabled"
      icon="iconfont icondayin"
    >
      <!-- <i class="iconfont icondayin" v-show="!options.isHideIcon?true:false"></i> -->
      {{ !options.hideTitle ? options.btnTitle : '' }}
    </el-button>
  </span>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'Print',
  data () {
    return {
      versionMsg: '',
      keyBtn: false,
      hasLodop: false,
      hasBeforePrint: true,
      language: '',
    }
  },
  props: {
    getPrintData: Function,
    beforePrint: Function,
    typeName: {
      type: String,
      default: () => {
        return 'oneAndtwoLinkPage'
      }, // 是否有一联两联面单，默认有
    },
    options: {
      type: Object,
      default: () => {
        return {
          btnTitle: this.$lang('打印123'),
          btnType: '',
        }
      },
    },
    hasPower: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters(['langList']),
    // 用户信息
    userInfo () {
      return this.$store.state.base.user || {}
    },
  },
  methods: {
    ...mapActions(['SET_USER', 'LOGIN_INIT', 'SET_SYSTEM_MENU']),
    async openMenu (e) {
      if (e) {
        this.event = e
      }
      if (this.beforePrint && this.hasBeforePrint) {
        this.beforePrint()
        return
      }
      this.hasBeforePrint = true
      const langListFilter = { abled: true, val: this.$lang('英语'), value: 'EN' }
      this.language = langListFilter.value
      this.showLinks(e)
    },
    // 一联两联打印
    showLinks (e) {
      const menuList = [

        {
          val: this.$lang('两联面单'),
          abled: true,
          value: 'twoLinkPage',
        },
        {
          val: this.$lang('一联面单'),
          abled: true,
          value: 'oneLinkPage',
        },
        {
          val: this.$lang('A4打印模板'),
          abled: true,
          value: 'threeLinkPage',
        },
      ]
      const surfaceFormat = this.userInfo.surfaceFormat
      if (surfaceFormat === 2) {
        this.toPrint(menuList[1].value)
      } else if (surfaceFormat === 3) {
        this.toPrint(menuList[0].value)
      } else if (surfaceFormat === 4) {
        this.toPrint(menuList[2].value)
      } else {
        let left, top
        if (e) {
          left = this.$refs.btnPrint.$el.getBoundingClientRect().left + this.$refs.btnPrint.$el.getBoundingClientRect().width / 2
          top = this.$refs.btnPrint.$el.getBoundingClientRect().top + this.$refs.btnPrint.$el.getBoundingClientRect().height / 2
        }
        this.$rightMenu.open({
          target: e,
          menuList: menuList,
          posobj: {
            left: e.clientX || left,
            top: e.clientY || top,
          },
          callback: ({ value }) => {
            this.toPrint(value)
          },
        })
      }
    },
    // 选择面单后去打印
    async toPrint (value) {
      this.keyBtn = true
      this.$rightMenu.close()
      try {
        const type = value && value === 'oneLinkPage' ? 1 : value && value === 'twoLinkPage' ? 2 : 3
        const pdfBase = await this.getPrintData(type, this.language)
        pdfBase && window.open(pdfBase)
        this.keyBtn = false
      } catch (err) {
        this.keyBtn = false
      }
    },
  },
}
</script>
<style lang="scss" >
#myCanvas {
  position: absolute;
  right: 9999px;
}
</style>
